// @ts-nocheck
import React, { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import device from 'common/support/device';
import config from 'config';

import Dialog from 'components/common/Dialog';

import { closeExitDialog } from 'actions/exitDialog';
import appActions from 'common/support/applicationActions';

const messages = {
  exitLabel: {
    id: 'exit.page.label',
    description: 'Exit dialog label',
  },
  exitConfirmation: {
    id: 'exit.page.confirmation',
    description: 'Exit dialog message',
  },
  exitYes: {
    id: 'exit.page.button.yes',
    description: 'Exit dialog confirm button',
  },
  exitNo: {
    id: 'exit.page.button.no',
    description: 'Exit dialog cancel button',
  },
};

const ExitDialog = () => {
  const intl = useIntl();
  const isOpen = useSelector(state => state.exitDialog.isOpen);
  const dispatch = useDispatch();

  const onConfirm = useCallback(() => {
    device.exitApp();
  }, []);

  const onCancel = useCallback(() => {
    dispatch(closeExitDialog());
  }, [dispatch]);

  return (
    <Dialog
      isOpen={isOpen}
      title={intl.formatMessage(messages.exitLabel)}
      message={intl.formatMessage(messages.exitConfirmation, {
        brand: config.brand.name,
      })}
      onActionOverride={action => {
        if (action === appActions.exit) {
          onConfirm();
          return true;
        }
        if (action === appActions.back) {
          onCancel();
          return true;
        }
        return false;
      }}
      positiveCTA={intl.formatMessage(messages.exitYes)}
      onPositive={onConfirm}
      negativeCTA={intl.formatMessage(messages.exitNo)}
      onNegative={onCancel}
      initialFocus="negative"
    />
  );
};

export default ExitDialog;
